import React from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Select from 'Components/ComponentLibrary/Atoms/Inputs/Select';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { CURRENT_TIMEFRAME } from 'Components/ComponentLibrary/Organisms/ScenarioChart';
import TimeframePaginator from './TimeframePaginator';

const styles = theme => ({
  root: {
  },
  timeframeSelector: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  goToCurrentButton: {
    marginRight: theme.spacing(1),
  },
});

const TimeframeOptions = ({
  classes,
  isLoading,
  timeFrameOptions,
  handleOnChange,
  handleSetTimeframeToCurrent,
  handleOnNext,
  handleOnPrev,
  nextOption,
  prevOption,
  timeFrame,
}) => {
  const isTimeframeCurrent = Boolean(timeFrame && timeFrame === CURRENT_TIMEFRAME);
  const hasTimeFrameOptions = Boolean(timeFrameOptions && timeFrameOptions.length >= 1);
  if (!hasTimeFrameOptions) {
    return null;
  }

  const currentOptionLabel = timeFrameOptions[0].name;

  return (
    <Box className={classes.timeframeSelector}>
      {!isTimeframeCurrent ? (
        <RoundedButton
          color={'white'}
          onClick={handleSetTimeframeToCurrent}
          padding={'dense'}
          size={'xs'}
          className={classes.goToCurrentButton}
          test={'current-timeframe-button'}
        >
          <Text
            noWrap
            component="span"
            text={`View ${currentOptionLabel}`}
            weight="bold"
          />
        </RoundedButton>) : null
      }
      <Select
        color="white"
        onChange={handleOnChange}
        options={timeFrameOptions}
        padding="dense"
        test="table-timeframe-select"
        size="xs"
        value={timeFrame}
        variant="contained"
        weight="bold"
      />
      <TimeframePaginator
        onNext={handleOnNext}
        nextDisabled={!nextOption || isLoading}
        onPrevious={handleOnPrev}
        previousDisabled={!prevOption || isLoading}
      />
    </Box>
  );
};

TimeframeOptions.defaultProps = {
};

TimeframeOptions.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  timeFrameOptions: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleSetTimeframeToCurrent: PropTypes.func.isRequired,
  handleOnNext: PropTypes.func.isRequired,
  handleOnPrev: PropTypes.func.isRequired,
  nextOption: PropTypes.bool.isRequired,
  prevOption: PropTypes.bool.isRequired,
  timeFrame: PropTypes.string.isRequired,
};

export default withStyles(styles)(TimeframeOptions);
